import { AutoComplete } from 'primereact/autocomplete';
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { classNames } from "primereact/utils";
import { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { Generico } from './Generico';
import { ColorPicker } from 'primereact/colorpicker';
import { MultiSelect } from 'primereact/multiselect';
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { InputMask } from "primereact/inputmask";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import './estilo.css';
import { Menu } from 'primereact/menu';
import { getOpcionesFiltroFecha, getOpcionesFiltroTexto, getOpcionesFiltroNumerico, getOpcionesFiltroMultiSelect } from '../utils/TableTemplates';
import { Chips } from 'primereact/chips';
import { PanelAyuda } from './ui/PanelAyuda';

export const InputComponent = ({ registers, omodel, errors, control, permss, id, soloLectura, filters = null, olista = null }) => {

    const menuRef = useRef(null);
    const model = olista ? omodel[olista] : omodel.model;
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const { getFormErrorMessage, paramLazy, endOfToday, dateFormat } = Generico();
    const [lazyParams, setLazyParams] = useState(paramLazy());
    const [filtros, setFiltros] = useState();

    useEffect(() => {
        setFiltros(valoresModel('match'));
    }, []);

    const formatCurrency = (value) => {
        const numeric = typeof value === 'string' ? parseFloat(value) : value;
        return numeric?.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const numericFilterTemplate = (options) => {
        return (
            <InputText value={options.value || ''} keyfilter="num" style={{ width: '100%' }}
                onChange={(e) => {
                    const val = e.target.value;
                    options.filterCallback(val, options.index);
                    options.filterApplyCallback(val, options.index);
                }}
            />
        );
    };

    const dateFilterTemplate = (options) => {
        const handleChange = (e) => {
            const newDate = e.value;
            const currentDate = options.value ? new Date(options.value) : null;
            const isDifferent =
                (newDate && !currentDate) ||
                (!newDate && currentDate) ||
                (newDate && currentDate && newDate.getTime() !== currentDate.getTime());
            if (isDifferent) {
                options.filterApplyCallback(newDate, options.index);
            }
        };

        return (
            <Calendar value={options.value ? new Date(options.value) : null} onChange={handleChange} dateFormat="yy-mm-dd" placeholder="Fecha" mask="9999-99-99" className="p-column-filter" readOnlyInput />
        );
    };

    const multiSelectTemplate = (optionsParam, options) => {
        const onMultiChange = (e) => {
            const vals = e.value;
            optionsParam.filterApplyCallback(
                !vals || vals.length === 0 ? null : vals
            );
        };
        return (
            <MultiSelect value={optionsParam.value || []} options={options} onChange={onMultiChange} optionLabel="label" optionValue="value" placeholder="Seleccione" className="p-column-filter" display="chip" filter showSelectAll={false} />
        );
    };

    const noEdit = () => {
        if (soloLectura) return true;
        if (!permss) return false;
        return id != null ? !permss?.actualizar : !permss?.crear;
    }

    const onPage = (event) => {
        event.filters = lazyParams.filters;
        setLazyParams(event);
    }

    const onSort = (event) => {
        event.filters = lazyParams.filters;
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const inFile = (field, option = {}, col = 12) => {
        const obl = option.obl ? "*" : "";
        const ml = option.ml || '';
        const ne = option.ne !== undefined ? option.ne : noEdit();
        const ro = option.rop !== undefined ? option.rop : false;

        const fileSize = option.fileSize || 0;
        const setFileSize = option.setFileSize;

        const headerTemplate = (opciones) => {
            const { className, chooseButton } = opciones;
            const progreso = fileSize / 10000;
            const tamanoFormateado = (fileSize / 1000000).toFixed(2) + ' MB';
            return (
                <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                    {chooseButton}
                    <div className="flex align-items-center gap-3 ml-auto">
                        <span>{tamanoFormateado} / 1 MB</span>
                        <ProgressBar value={progreso} showValue={false} style={{ width: '10rem', height: '12px' }} />
                    </div>
                </div>
            );
        };

        const emptyTemplate = () => {
            return (
                <div className="flex align-items-center justify-content-center" style={{ height: '100%' }}>
                    <i className="pi pi-image" style={{ fontSize: '1.5rem', borderRadius: '50%', marginRight: '0.5rem' }}></i>
                    <span style={{ fontSize: '1em', color: 'var(--text-color-secondary)' }}>
                        Arrastra y suelta una imagen aquí
                    </span>
                </div>
            );
        };

        return (
            <div className={"field col-" + col + ml}>
                {model[field].header && (
                    <>
                        <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}>
                            {model[field].header}{obl}
                        </label><br />
                    </>
                )}
                <Controller name={field} control={control} defaultValue={null} rules={{ required: model[field].required }}
                    render={({ field }) => (
                        <FileUpload name={field.name} accept="image/*" maxFileSize={1000000} chooseLabel="Seleccionar Logo" headerTemplate={headerTemplate} emptyTemplate={emptyTemplate} disabled={ne} readOnly={ro}
                            onSelect={(e) => {
                                const file = e.files[0];
                                if (file) {
                                    field.onChange(file); // guarda el File puro, sin base64
                                    if (setFileSize) setFileSize(file.size);
                                }
                            }}
                            onRemove={() => {
                                field.onChange(null);
                                if (setFileSize) setFileSize(0);
                            }}
                        />
                    )}
                />
                {getFormErrorMessage(errors, field)}
            </div>
        );
    };

    const inSwitch = (field, option = {}, col = 3) => {

        const labelTrue = option.labelTrue || 'SI';  // Si no se pasa, será "SI"
        const labelFalse = option.labelFalse || 'NO';  // Si no se pasa, será "NO"

        const obl = option.obl ? "" : "*";
        const ml = option.ml ? option.ml : '';
        const ne = option.ne !== undefined ? option.ne : noEdit();
        const ro = option.rop !== undefined ? option.rop : false;
        const tooltipText = option.tooltip || "Haga clic para cambiar de estado";

        return (
            <div className={"field col-" + col + ml}>
                {model[field].header !== '' && (<> <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}> {model[field].header}{obl} </label> <br /> </>)}
                <Controller name={field} control={control} render={({ field }) => (
                    <div className="flex align-items-center" style={{ marginTop: '5px' }}>
                        <InputSwitch id={field.name} checked={field.value} onChange={(e) => field.onChange(e.value)} disabled={ne} readOnly={ro}
                            tooltip={tooltipText} tooltipOptions={{ position: 'bottom' }} className={`custom-inputswitch ${field.value ? 'p-inputswitch-checked' : ''}`} />
                        <Tag value={field.value ? labelTrue : labelFalse} severity={field.value ? "warning" : undefined}
                            style={!field.value ? { background: "#e0e0e0", color: "#716d67" } : undefined} className="ml-3" />
                    </div>
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        );
    };

    const inDrop = (field, items, option = {}, col = 3) => {
        let obl = model[field]?.required ? "*" : "";
        if (option.obl === false) obl = "";
        if (option.obl === true) obl = "*";
        const ml = option.ml ? option.ml : '';
        const ne = option.ne !== undefined ? option.ne : noEdit();
        const ro = option.rop !== undefined ? option.rop : false;
        const _label = option.etiqueta ?? model[field].header;
        const helpContent = option.helpContent ?? model[field]?.helpContent;

        return (
            <div className={"field col-" + col + ml}>
                {model[field].header !== '' && (
                    <div className="flex align-items-center mb-2">
                        <label htmlFor={field} className={classNames("font-medium text-800 text-sm mb-0", { 'p-error': errors[field] })}>
                            {_label}{obl}
                        </label>
                        {helpContent && <PanelAyuda content={helpContent} />}
                    </div>
                )}
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <Dropdown id={field.name} value={field.value} onChange={(e) => { field.onChange(e.value === undefined ? null : e.value); if (option.chn) { if (option.val) { option.chn(e, option.val); } else { option.chn(e); } } }} options={items}
                        optionLabel={option.lab} placeholder="Seleccione" filter showClear={option.showClear !== undefined ? option.showClear : true} filterBy={option.lab} className={classNames({ 'p-invalid': fieldState.error })}
                        style={{ width: '100%' }} disabled={ne} readOnly={ro} />
                )} />
                {getFormErrorMessage(errors, field)}
                {option.helpText && (
                    <small className="block mt-1 text-orange-600 font-medium flex align-items-center gap-1" style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>
                        <i className="pi pi-info-circle text-xs" />
                        {option.helpText}
                    </small>
                )}
            </div>
        )
    }

    const inDropMultiple = (field, items, option = {}, col = 3) => {
        const obl = option.obl ? "" : "*";
        const ml = option.ml ? option.ml : '';
        const ne = option.ne !== undefined ? option.ne : noEdit();
        return (
            <div className={"field col-" + col + ml}>
                {model[field].header !== '' && (
                    <label htmlFor={field} className={classNames("font-medium text-800 text-sm", { 'p-error': errors[field] })}>
                        {model[field].header}{obl}
                    </label>
                )}
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <MultiSelect onChange={(e) => { field.onChange(e.value); if (option.chn) { if (option.val) { option.chn(e, option.val); } else { option.chn(e); } } }}
                        options={items} id={field.name} value={field.value}
                        optionLabel={option.lab} placeholder="Seleccione" filter showClear filterBy={option.lab} className={classNames({ 'p-invalid': fieldState.error })}
                        style={{ width: '100%' }} disabled={ne} display="chip" />
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inChips = (field, option = {}, col = 6) => {
        const _label = option.etiqueta ?? model[field]?.header ?? field;
        const readOnly = option.readOnly ?? false;
        const max = option.max ?? model[field]?.max;

        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}>
                    {_label}
                    <span className="text-500 font-normal ml-2 text-xs">(Presione Enter para agregar)</span>
                </label>
                <Controller name={field} control={control}
                    render={({ field: { onChange, value }, fieldState }) => {
                        // Cálculo de caracteres. Los chips se separan por comas, cuantan como caracter.
                        const currentString = Array.isArray(value) ? value.join(',') : '';
                        const currentLength = currentString.length;
                        return (
                            <>
                                <Chips id={field.name} value={value} className={classNames({ 'p-invalid': fieldState.error })} separator="," addOnBlur={true} allowDuplicate={false} disabled={noEdit() || readOnly} itemTemplate={(item) => (<span className="p-1">{item}</span>)}
                                    onChange={(e) => {
                                        const newValue = e.value;
                                        const newString = newValue.join(',');
                                        const newLength = newString.length;
                                        // Si no hay max definido, permite todo. Si la nueva longitud es menor o igual al max, permite. Si la nueva longitud es menor a la actual (borró un chip), permite.
                                        if (!max || newLength <= max || newLength < currentLength) {
                                            onChange(newValue);
                                        } else {
                                            // Caso contrario, no agregar el chip, si se desea mostrar una alerta aquí.
                                        }
                                    }}
                                />
                                <div className="flex justify-content-between mt-1 gap-3">
                                    <small className="text-gray-500">
                                        {option.helpText}
                                    </small>

                                    {max && (
                                        <small style={{ color: currentLength >= max ? 'red' : '#6c757d', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                            {currentLength} / {max} caracteres
                                        </small>
                                    )}
                                </div>
                            </>
                        );
                    }}
                />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inText = (field, option = {}, col = 3) => {
        let readOnly = false;
        if (option.readOnly !== undefined) {
            readOnly = option.readOnly;
        }
        let keyFilter = null;
        if (option.keyFilter) {
            keyFilter = option.keyFilter;
        }
        let minValLen = model[field].min;
        let minMesLen = model[field].minLength;
        if (option.minValLen) {
            minValLen = option.minValLen;
            minMesLen = option.minMesLen;
        }
        let maxValLen = model[field].max;
        let maxMesLen = model[field].maxLength;
        if (option.maxValLen) {
            maxValLen = option.maxValLen;
            maxMesLen = option.maxMesLen;
        }
        let rules = {
            required: model[field].required, maxLength: { value: maxValLen, message: maxMesLen },
            minLength: { value: minValLen, message: minMesLen }
        }
        if (option.pattern) {
            rules['pattern'] = option.pattern;
        }
        let obl = model[field].required ? "*" : "";
        if (option.obl === false) obl = "";
        if (option.obl === true) obl = "*";
        if (option.validate) {
            rules['validate'] = option.validate;
        }
        const helpContent = option.helpContent ?? model[field]?.helpContent;

        return (
            <div className={"field col-" + col}>
                <div className="flex align-items-center mb-2">
                    <label htmlFor={field} className={classNames("font-medium text-800 text-sm mb-0", { 'p-error': errors[field] })}>
                        {model[field].header}{obl}
                    </label>
                    {helpContent && <PanelAyuda content={helpContent} />}
                </div>
                <Controller name={field} control={control} rules={rules} render={({ field, fieldState }) => (
                    option.icon ? (
                        <IconField iconPosition={option.iconPosition || 'left'}>
                            <InputIcon className={option.icon} />
                            <InputText id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.error })} readOnly={readOnly} keyfilter={keyFilter} maxLength={maxValLen}
                                style={{ width: '100%' }} disabled={noEdit()} />
                        </IconField>
                    ) : (
                        <InputText id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.error })} readOnly={readOnly} keyfilter={keyFilter} maxLength={maxValLen}
                            style={{ width: '100%' }} disabled={noEdit()} />
                    )
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inNumber = (field, decimal, curren, opc = {}, col = 3) => {
        const mode = curren ? 'currency' : 'decimal';
        const local = 'en-US';
        const currency = 'USD';
        let disabled = noEdit();
        if (!noEdit()) {
            disabled = opc.disabled ? opc.disabled : false;
        }
        let obl = model[field]?.required ? "*" : "";
        if (opc.obl === false) obl = "";
        if (opc.obl === true) obl = "*";
        let min = model[field]?.min !== undefined ? model[field].min : null;
        if (opc.min !== undefined) {
            min = opc.min === 'nulo' ? null : opc.min;
        }
        let max = model[field]?.max !== undefined ? model[field].max : null;
        if (opc.max !== undefined) {
            max = opc.max === 'nulo' ? null : opc.max;
        }
        const tooltip = opc.tooltip ?? null;
        const useGrouping = opc.useGrouping ?? true;
        const helpContent = opc.helpContent ?? model[field]?.helpContent;

        return (
            <div className={"field align-right col-" + col}>
                {model[field].header && (
                    <div className="flex align-items-center mb-2">
                        <label htmlFor={field} className={classNames("font-medium text-800 text-sm mb-0", { 'p-error': errors[field] })}>
                            {model[field].header}{obl}
                        </label>
                        {helpContent && <PanelAyuda content={helpContent} />}
                    </div>
                )}

                <Controller name={field} control={control} rules={{
                    required: model[field].required,
                    min: min !== null ? (typeof min === 'object' ? min : { value: min, message: `Mínimo valor es ${min}` }) : undefined,
                    max: max !== null ? (typeof max === 'object' ? max : { value: max, message: `Máximo valor es ${max}` }) : undefined
                }} render={({ field, fieldState }) => (
                    opc.icon ?
                        (
                            <div style={{ position: 'relative', width: '100%' }}>
                                <i className={opc.icon} style={{ position: 'absolute', left: opc.iconPosition === 'right' ? 'auto' : '0.75rem', right: opc.iconPosition === 'right' ? '0.75rem' : 'auto', top: '50%', transform: 'translateY(-50%)', zIndex: 1, pointerEvents: 'none' }} />
                                <InputNumber id={field.name} value={field.value} onBlur={field.onBlur} onChange={(e) => { field.onChange(e.value); if (opc.func) { opc.func(e, opc.vars) } }}
                                    maxFractionDigits={decimal} tooltip={tooltip} suffix={opc.suffix} placeholder={opc.placeholder}
                                    className={classNames({ 'p-invalid': fieldState.error })} mode={mode} locale={local} currency={currency} disabled={disabled} style={{ width: '100%' }}
                                    useGrouping={useGrouping} />
                            </div>
                        )
                        : (
                            <InputNumber id={field.name} value={field.value} onBlur={field.onBlur} onChange={(e) => { field.onChange(e.value); if (opc.func) { opc.func(e, opc.vars) } }}
                                maxFractionDigits={decimal} tooltip={tooltip} suffix={opc.suffix} placeholder={opc.placeholder}
                                className={classNames({ 'p-invalid': fieldState.error })} mode={mode} locale={local} currency={currency} disabled={disabled} style={{ width: '100%' }}
                                useGrouping={useGrouping} />
                        )
                )} />
                {getFormErrorMessage(errors, field)}
                {opc.helpText && (
                    <small className="block mt-1 text-orange-600 font-medium flex align-items-center gap-1" style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>
                        <i className="pi pi-info-circle text-xs" />
                        {opc.helpText}
                    </small>
                )}
            </div>
        )
    }

    const inMask = (field, opc = {}, col = 3) => {
        let disabled = noEdit();
        if (!noEdit()) {
            disabled = opc.disabled ? opc.disabled : false;
        }
        const ast = opc?.ast ?? '*;'
        const tooltip = opc.tooltip ?? null;
        const mask = opc?.mask ?? '9999999999999?';
        const pl = opc?.pl ?? '5930409999999';

        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}>{model[field].header}{ast}</label><br />
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <InputMask id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} mask={mask} placeholder={pl} tooltip={tooltip}
                        className={classNames({ 'p-invalid': fieldState.error })} disabled={disabled} style={{ width: '100%' }} autoClear={false} />
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inInteger = (field, col = 3) => {
        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}>{model[field].header}*</label><br />
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <InputNumber id={field.name} value={field.value} onChange={(e) => { field.onChange(e.value) }} min={0} maxFractionDigits={0}
                        className={classNames({ 'p-invalid': fieldState.error })} disabled={noEdit()} />
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inCheck = (field, lbl, option = {}, col = 3) => {

        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}>{lbl ? lbl : model[field].header}</label><br />
                <Controller name={field} control={control} render={({ field, fieldState }) => (
                    <Checkbox inputId={field.name} value={field.value} onChange={(e) => { field.onChange(e.checked); if (option.chn) { if (option.val) { option.chn(e, option.val); } else { option.chn(e); } } }} checked={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })} disabled={noEdit()} />
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inArea = (field, rows, cols, col = 3, op = {}) => {
        let obl = model[field]?.required ? "*" : "";
        if (op.obl === false) obl = "";
        if (op.obl === true) obl = "*";
        const max = model[field].max;
        const readOnly = op.readOnly ?? false;
        const helpContent = op.helpContent ?? model[field]?.helpContent;
        return (
            <div className={"field col-" + col}>
                <div className="flex align-items-center mb-2">
                    <label htmlFor={field} className={classNames("font-medium text-800 text-sm mb-0", { 'p-error': errors[field] })}>
                        {model[field].header}{obl}
                    </label>
                    {helpContent && <PanelAyuda content={helpContent} />}
                </div>
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <>
                        <InputTextarea rows={rows} cols={cols} id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.error })} style={{ maxWidth: '100%' }} maxLength={max} readOnly={readOnly} disabled={noEdit()} />
                        {max && !readOnly && (
                            <small style={{ color: (field.value?.length || 0) >= max ? 'red' : '#6c757d', float: 'right' }}>
                                {field.value?.length || 0} / {max} caracteres
                            </small>
                        )}
                    </>
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inRadio = (field, items, option = {}) => {
        const col = option.col ?? 3;
        const obl = option.obl ?? "*";
        const param = option.param ?? null;
        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}>{model[field].header}{obl}</label><br />
                <div className={"flex flex-wrap gap-3"}>
                    <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                        items.map((item) => {
                            return (
                                <div key={item.id} className="flex align-items-center">
                                    <RadioButton inputId={item.id} name={field.name} value={item.id} onChange={(e) => { field.onChange(e.value); if (option.onChange) { option.onChange(e.value, param) } }}
                                        checked={field.value === item.id} className={classNames({ 'p-invalid': fieldState.error })} />
                                    <label htmlFor={item.id} className="ml-2">{item.name}</label>&nbsp;&nbsp;&nbsp;
                                </div>
                            );
                        })
                    )} />
                    {getFormErrorMessage(errors, field)}
                </div>
            </div>
        )
    }

    const inCalendar = (field, option = {}, col = 3) => {

        let obl = "*";
        if (option.obl) {
            obl = "";
        }
        let maxDate = endOfToday;
        let minDate = null;
        if (option.min) {
            minDate = option.minNull ? null : endOfToday;
            maxDate = null;
        }
        // Usamos hasOwnProperty para saber si se envió la propiedad, incluso si es null
        if (option.hasOwnProperty('minDate')) {
            minDate = option.minDate;
        }
        if (option.hasOwnProperty('maxDate')) {
            maxDate = option.maxDate;
        }
        const helpContent = option.helpContent ?? model[field]?.helpContent;

        return (
            <div className={"field col-" + col}>
                <div className="flex align-items-center mb-2">
                    <label htmlFor={field} className={classNames("font-medium text-800 text-sm mb-0", { 'p-error': errors[field] })}>
                        {model[field].header}{obl}
                    </label>
                    {helpContent && <PanelAyuda content={helpContent} />}
                </div>
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => {
                    const fieldValue = field.value ? new Date(field.value) : null;
                    return (
                        <Calendar id={field.name} value={fieldValue} onChange={(e) => { field.onChange(e.value); if (option.onChange) { option.onChange(e.value); } }} maxDate={maxDate} minDate={minDate}
                            showButtonBar dateFormat={dateFormat} showIcon disabled={option.hasOwnProperty('disabled') ? option.disabled : noEdit()} className={classNames({ 'p-invalid': fieldState.error })} readOnlyInput />
                    );
                }}
                />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inAutocomplete = (field, selected, setSelected, suggs, search, option = {}) => {
        let col = 3;
        if (option.col) {
            col = option.col;
        }
        const actividadHelpText = option.noEsActividad ? null : (
            <small className="text-color-secondary mt-1 block line-height-3">
                Se encuentra cargado un catálogo de actividades económicas. Por favor, escriba una referencia (ej: <strong>ENSEÑANZA</strong>) y seleccione una opción de la lista.
            </small>
        );

        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames("font-medium text-800 text-sm", { 'p-error': errors[field] })}>
                    {option.customLabel ? option.customLabel : model[field].header}*
                </label>
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <AutoComplete id={field.name} value={field.value} onChange={(e) => { field.onChange(e.value); setSelected(e.value) }} suggestions={suggs} tooltip={selected?.nombre}
                        onSelect={(e) => { if (option.onSelect && typeof option.onSelect === 'function') { option.onSelect(e.value); } }}
                        completeMethod={e => { if (option.val) { search(e, option.val) } else { search(e) } }} field={option.lab} dropdownAriaLabel="Seleccione" className={classNames({ 'p-invalid': fieldState.error })}
                        tooltipOptions={{ position: 'top', style: { maxWidth: '350px' } }} inputStyle={{ width: '100%' }} style={{ width: '100%' }} disabled={noEdit()} dropdown dropdownIcon="pi pi-search"
                        placeholder='Ingrese el texto a buscar y seleccione de la lista presentada.' />
                )} />
                {actividadHelpText}
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const filterSelectTemplate = (options, info, inx) => {
        return (
            <Dropdown value={options.value} options={filters[inx]} onChange={(e) => options.filterApplyCallback(e.value)} optionLabel={model[info].lab}
                placeholder="Seleccione" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
        );
    };

    const valoresModel = (opcion, opc = {}) => {
        let icolumn = [];
        if (opcion === 'match') {
            icolumn = {};
        }
        Object.keys(model).forEach(info => {
            switch (opcion) {
                case 'table':
                    if (model[info].table) {
                        const sfilterField = model[info].filterField !== undefined ? model[info].filterField : info;
                        const sfilterPlaceholder = model[info].filterPlaceholder !== undefined ? model[info].filterPlaceholder : "";
                        let showFilterMatchModes = true;
                        if (model[info].showFilterMatchModes !== undefined) {
                            showFilterMatchModes = model[info].showFilterMatchModes;
                        }
                        let headerStyle = {};
                        if (model[info].headerStyle) {
                            headerStyle = model[info].headerStyle;
                        }
                        let footer = null;
                        if (model[info]?.footer !== undefined && model[info]?.footer !== null) {
                            footer = model[info].footer;
                            if (opc?.footers && opc?.footers[info]) {
                                footer = opc.footers[info];
                            }
                        }

                        if (model[info].isDate) {
                            icolumn.push(
                                <Column key={info} field={info} header={model[info].header} sortable={model[info].sort} filter={model[info].filter} filterField={sfilterField} filterElement={dateFilterTemplate}
                                    filterMatchModeOptions={getOpcionesFiltroFecha()} showFilterMatchModes={showFilterMatchModes} headerStyle={headerStyle} footer={footer} frozen={model[info].frozen} />
                            );
                        } else if (model[info].isMultiselect) {
                            const options = opc?.catalogos?.[model[info].catalogKey] || [];
                            icolumn.push(
                                <Column key={info} field={info} header={model[info].header} sortable={model[info].sort} filter filterElement={(optionsParam) => multiSelectTemplate(optionsParam, options)}
                                    filterField={sfilterField} filterMatchModeOptions={getOpcionesFiltroMultiSelect()} frozen={model[info].frozen} />
                            );
                        } else if (model[info]?.isNumeric) {
                            icolumn.push(
                                <Column key={info} field={info} header={model[info].header} sortable={model[info].sort} filter={model[info].filter} filterElement={numericFilterTemplate}
                                    filterField={sfilterField} filterPlaceholder={sfilterPlaceholder} filterMatchModeOptions={getOpcionesFiltroNumerico()} headerStyle={headerStyle}
                                    body={(rowData) => {
                                        const formatted = model[info].isCurrency ? formatCurrency(rowData[info]) : rowData[info];
                                        return <span>{formatted}</span>;
                                    }} footer={footer} frozen={model[info].frozen}
                                />
                            );
                        }
                        else if (model[info]?.tag) {
                            icolumn.push(<Column key={info} field={info} header={model[info].header} sortable={model[info].sort} filter={model[info].filter} filterField={sfilterField}
                                filterPlaceholder={sfilterPlaceholder} showFilterMatchModes={showFilterMatchModes} headerStyle={headerStyle} footer={footer} body={(rowData) => fieldTemplate(rowData, info)} frozen={model[info].frozen} />);
                        } else if (model[info]?.filterSelect >= 0) {
                            icolumn.push(<Column key={info} field={info} header={model[info].header} sortable={model[info].sort} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }}
                                filter={model[info].filter} filterElement={(options) => filterSelectTemplate(options, info, model[info]?.filterSelect)} body={(rowData) => fieldTemplate(rowData, info)}
                                showFilterMenu={false} frozen={model[info].frozen} />);
                        } else {
                            icolumn.push(<Column key={info} field={info} header={model[info].header} sortable={model[info].sort} filter={model[info].filter} filterField={sfilterField}
                                filterPlaceholder={sfilterPlaceholder} showFilterMatchModes={showFilterMatchModes} headerStyle={headerStyle} footer={footer} frozen={model[info].frozen}
                                filterMatchModeOptions={getOpcionesFiltroTexto()} style={{ whiteSpace: 'pre-wrap' }} />);
                        }
                    }
                    break;
                case 'match':
                    if (model[info].table) {
                        if (model[info].matchMode) {
                            let _item = { value: null, matchMode: model[info].matchMode };
                            if (model[info].operator) {
                                _item = { operator: model[info].operator, constraints: [_item] }
                            }
                            const sfilterField = model[info].filterField !== undefined ? model[info].filterField : info;
                            icolumn[sfilterField] = _item;
                        }
                    }
                    break;
                default:
                    break;
            }
        });

        return icolumn;
    }

    const fieldTemplate = (data, field) => {
        let inf = data[field];
        if (model[field].tag === true || data[field] === model[field]?.tag) {
            inf = <>{inf}<br /><Tag value={model[field].mtaq} severity={model[field].severity}></Tag></>;
        } else if (model[field]?.taq === 'same' && inf && inf.trim() !== "") {
            inf = <><Tag value={inf} severity={model[field].severity}></Tag></>;
        }
        return inf;
    };

    const table = (opc = {}) => {

        let action = valoresModel('table', opc);
        if (opc.action01) {
            action.push(<Column body={(rowData) => opc.action01(rowData, opc.reg, menuRef)} key="action" />);
        }
        if (opc.action0) {
            action.push(<Column body={(rowData) => opc.action0(rowData)} key="action" />);
        }
        if (opc.action) {
            action.push(<Column body={(rowData) => opc.action(rowData, opc.methEdit, opc.perm, opc.methDelete)} key="action" />);
        }
        if (opc.action2) {
            action.push(<Column body={(rowData) => opc.action2(rowData, opc.methEdit, opc.perm, opc.methDelete, opc.add)} key="action" />);
        }
        if (opc.action3) {
            action.push(<Column body={(rowData) => opc.action3(rowData, opc.methEdit, opc.icono, opc.details, opc.perm, opc.methDelete)} key="action" />);
        }
        if (opc.action4) {
            action.push(<Column body={(rowData) => opc.action4(rowData, opc.methEdit, opc.icono, opc.details, opc.perm, opc.methDelete, opc.load, opc.idv)} key="action" />);
        }
        if (opc.action5) {
            action.push(<Column body={(rowData) => opc.action5(rowData, opc.methEdit, opc.icono, opc.details, opc.perm, opc.methDelete, opc.iconExtra, opc.methExtra)} key="action" />);
        }
        return (
            <>
                <Menu model={opc.items} popup ref={menuRef} id="popup_menu_center" onShow={() => { const elements = document.querySelectorAll('a[aria-hidden="true"]'); elements.forEach(el => el.removeAttribute('aria-hidden')); }} />
                <DataTable value={registers} lazy className="datatable-responsive"
                    filterDisplay="row" dataKey="id"
                    paginator first={parseInt(lazyParams.first)} rows={parseInt(process.env.REACT_APP_ROWS_NUM)} totalRecords={totalRecords} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter} filters={filtros} loading={loading} scrollable>
                    {action}
                </DataTable>
            </>

        )
    }

    const downloadPdf = (res, fileName) => {
        const fileURL = window.URL.createObjectURL(
            new Blob([res])
        );
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
        document.body.removeChild(fileLink);
    }

    const inNumberBasic = (field, decimal, curren, opc = {}) => {
        const mode = curren ? 'currency' : 'decimal';
        const local = 'en-US';
        const currency = 'USD';
        let disabled = noEdit();
        if (!noEdit()) {
            disabled = opc.disabled ? opc.disabled : false;
        }
        let min = 0;
        if (opc.min) {
            min = opc.min === 'nulo' ? null : opc.min;
        }
        const tooltip = opc.tooltip ?? null;

        return (
            <>
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <InputNumber id={field.name} value={field.value} onChange={(e) => { field.onChange(e.value); if (opc.func) { opc.func(e, opc.vars) } }}
                        min={min} maxFractionDigits={decimal} tooltip={tooltip} inputClassName="border-2 border-blue-500 rounded-md w-full bg-blue-100"
                        className={classNames({ 'p-invalid': fieldState.error })} mode={mode} locale={local} currency={currency} disabled={disabled} />
                )} />
                {getFormErrorMessage(errors, field)}
            </>
        )
    }

    const inColor = (field, col, opc = {}) => {
        let obl = "*";
        if (opc.obl) {
            obl = "";
        }

        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}>{model[field].header}{obl}</label><br />
                <Controller name={field} control={control} rules={{ required: model[field].required }} render={({ field, fieldState }) => (
                    <ColorPicker value={field.value} onChange={(e) => { field.onChange(e.value); if (opc.func) { opc.func(e, opc.vars) } }}
                        className={classNames({ 'p-invalid': fieldState.error })} />
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    const inComplete = (field, suggs, search, op = {}) => {
        const col = op.col ?? 3;
        const obl = op.obl ? "" : "*";
        const req = op.req ? op.req : 'Ingrese el texto a buscar y seleccione de la lista presentada.';

        return (
            <div className={"field col-" + col}>
                <label htmlFor={field} className={classNames({ 'p-error': errors[field] })}><b className="text-xs">{op.hd}{obl}</b></label><br />
                <Controller name={field} control={control} rules={{ required: req }} render={({ field, fieldState }) => (
                    <AutoComplete id={field.name} value={field.value} onChange={(e) => { field.onChange(e.value); if (op?.chn) { op.chn(e.value, field.name) } }} suggestions={suggs}
                        completeMethod={e => { if (op.val) { search(e, op.val) } else { search(e, op?.valor) } }} field={op.lab} dropdownAriaLabel="Seleccione" className={classNames({ 'p-invalid': fieldState.error })}
                        tooltipOptions={{ position: 'top' }} inputStyle={{ width: '100%' }} style={{ width: '100%' }} disabled={noEdit()} dropdown dropdownIcon="pi pi-search"
                        placeholder='Ingrese el texto a buscar y seleccione de la lista presentada.' tooltip={field.value?.nombre_completo} />
                )} />
                {getFormErrorMessage(errors, field)}
            </div>
        )
    }

    return {
        table,
        loading,
        setLoading,
        totalRecords,
        setTotalRecords,
        lazyParams,
        setLazyParams,
        onPage,
        inDrop,
        inFile,
        inSwitch,
        inText,
        inRadio,
        inArea,
        inNumber,
        inInteger,
        inCheck,
        inCalendar,
        inAutocomplete,
        downloadPdf,
        inNumberBasic,
        inColor,
        inDropMultiple,
        inMask,
        inComplete,
        inChips
    }
}
